export default "__VITE_ASSET__CpuhnKu8__"